import {IModalDialogHandler} from "../../dialog/dialog.service.interface";
import {GeoComplyFailureReason} from "./geo-comply-error-codes";
import {GeoLocationAnalytics} from "../geo-location-analytics";
import {IGeoRestrictionsUpdateEventParams} from "../../sdk/sdk-events";

export enum GeoLocationReason  {
    Login = 'Login',
    Periodic = 'Periodic',
    Retry = 'Retry',
    //AutoRetry = 'Auto Retry',
    OpenRealGame= 'OPEN_REAL_GAME'
};


export interface IGeoLocationStrategyRunParams {
    licenseKey: string;
    licenseWebKey: string;
    locationTransactionId: string;
    mobileNumber: string;
    reason: GeoLocationReason;
    progressIndicator?: IModalDialogHandler;
    analytics: GeoLocationAnalytics;

}

export interface IGeoComplyError {
    errorCode: number;
    errorMessage: string;
}

export interface IGeoComplyFailure {
    geoComplyError?: IGeoComplyError;
    additionalFailureReason: GeoComplyFailureReason;
}

export interface IGeoComplyResponse {
    data?: string;
    failure?: IGeoComplyFailure;
}

export enum GeoValidationResult {
    Fail,
    Pass
}

export interface IGeoRunResult {
    geoComplyFailure?: IGeoComplyFailure;
    validationResult: GeoValidationResult;
    kickParams?: IGeoRestrictionsUpdateEventParams;

}

export interface IGeoLocationStrategy {
    readonly shouldReloadOnGeoRetry: boolean;
    runGeoLocation(params: IGeoLocationStrategyRunParams): Promise<IGeoComplyResponse>;
    dispose(): void;
}